export default __webpack_public_path__ + "static/media/suporte.31dd7eb0.svg";